<template>
  <section class="section-base form-section-base">
    <v-container>
      <div class="form-base">
        <v-row>
          <v-col>
            <div class="form-base__title">
              Реквизиты счета для возврата должнику безналичных денежных
              средств, направленных в депозит нотариуса
            </div>
          </v-col>
        </v-row>

        <BankDetails :v="$v.debtorAccountBankDetails" />
      </div>

      <Footer
        @next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
        @prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
        :loading-next="loadingNext"
      />
    </v-container>
  </section>
</template>

<script>
import cloneDeep from 'clone-deep';

import { getValidationErrorText } from '@/utils/validate';
import { checkInvalid, leaveStep } from '@/utils/services';
import { ServicesModule } from '@/store/modules/services';
import Footer from '@/components/services/elements/Footer';
import { StepDirection, StepName } from '@/types/services';
import BankDetails, {
  bankDetails,
  bankDetailsValidation,
} from '@/components/services/elements/BankDetails';
import { AcceptanceDepositStep } from '@/constants';

export default {
  name: 'DebtorBankDetails',
  components: {
    Footer,
    BankDetails,
  },
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    StepDirection,
    StepName,
    leaveStep,
    getValidationErrorText,
    invalidFields: [],
    debtorAccountBankDetails: cloneDeep(bankDetails),
  }),
  validations: {
    debtorAccountBankDetails: bankDetailsValidation,
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    touchFields() {
      this.invalidFields = [];
      this.$v.$touch();
      checkInvalid(this.$v, this.invalidFields);
    },

    assemblyModel() {
      return cloneDeep(this.debtorAccountBankDetails);
    },

    prefillDraft() {
      if (!ServicesModule.statement.debtorAccountBankDetails) return;

      this.debtorAccountBankDetails = cloneDeep(
        ServicesModule.statement.debtorAccountBankDetails
      );
    },

    btnSaveClickHandler(direction) {
      leaveStep({
        stepThis: this,
        direction,
        step: AcceptanceDepositStep.DEBTOR_BANK_DETAILS,
      });
    },
  },
};
</script>
